<template>
    <v-container align="center">
        <v-row class="flex-column align-center">
            <span>
                {{text}} {{ (success) ? 'успешно' : 'неуспешно'}} <v-icon :color="(success) ? 'green' : 'red'">mdi-check</v-icon>
            </span>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'ActionResult',
  props: {
    text: {
      type: String,
      default: 'Действие было выполнено '
    },
    success: {
      type: Boolean,
      required: true
    }
  }
};
</script>
